var _rect, _rect2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.61845,
    y: 3.75473,
    width: 14.3441,
    height: 20.5955,
    rx: 2.99069,
    transform: "rotate(-8.25039 4.61845 3.75473)",
    fill: "#FB7401",
    stroke: "#FB7401",
    strokeWidth: 2.30053
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.584416,
    y: 8.88066,
    width: 14.3441,
    height: 20.5955,
    rx: 2.99069,
    transform: "rotate(-15.4826 0.584416 8.88066)",
    fill: "white",
    stroke: "#91BDFA",
    strokeWidth: 2.30053
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.71,
    y1: 10.6237,
    x2: 9.37012,
    y2: 11.2922,
    stroke: "#91BDFA",
    strokeWidth: 2.30053,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.8179,
    y1: 14.2976,
    x2: 7.88441,
    y2: 15.6431,
    stroke: "#91BDFA",
    strokeWidth: 2.30053,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard2);
export default __webpack_public_path__ + "static/media/Dashboard2.f0f89f6b505032e3576a7d23ee52a21b.svg";
export { ForwardRef as ReactComponent };